import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { animateScroll as scroll, scroller, Element } from 'react-scroll'; // eslint-disable-line

import SimpleNavBar from '../nav/SimpleNavBar';

import Header1 from '../../static/img/leadgen_pages/barefoot_topframe.png';
import Header2 from '../../static/img/leadgen_pages/barefoot_bottomframe.png';
import SolesForSouls from '../../static/img/leadgen_pages/soles_for_souls.png';
import AnnChristiansenHeadshot from '../../static/img/leadgen_pages/ann_christiansen_headshot.png';
import ShoesText from '../../static/img/leadgen_pages/shoes_text.png';
import FootPrints from '../../static/img/leadgen_pages/footprints.png';
import EpicCover from '../../static/img/leadgen_pages/epic_cover.png';

const DARK_BLUE = '#136a7e';
const GREY = '#022a33';
const RED = '#f63c57';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  container: {
    width: 'auto',
    [theme.breakpoints.up(1200)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  header: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontSize: '32px',
    letterSpacing: '0.1em',
    fontWeight: 'bold',
  },
  subheader: {
    marginBottom: theme.spacing(2),
    fontSize: '24px',
    letterSpacing: '0.1em',
    fontWeight: 'bold',
  },
  large: {
    fontSize: '50px',
    letterSpacing: '0.1em',
    fontWeight: 'bold',
  },
  small: {
    marginBottom: theme.spacing(2),
    fontSize: '22px',
  },
  headerContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down(960)]: {
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(6),
    },
    [theme.breakpoints.down(600)]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
    },
  },

  headerImg: {
    height: '200px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down(600)]: {
      height: '150px',
    },
  },
  headerImg1: {
    backgroundImage: `url(${Header2})`,
  },
  headerImg2: {
    backgroundImage: `url(${Header1})`,
  },
  red: {
    color: RED,
  },
  white: {
    color: 'white',
  },
  formHeader: {
    fontSize: '32px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  form: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up(900)]: {
      maxHeight: '300px',
    },
  },
  formContainer: {
    background: `linear-gradient(${DARK_BLUE}, ${GREY})`,
    borderRadius: '20px',
    padding: theme.spacing(4),
    position: 'relative',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up(900)]: {
      top: '-50px',
    },
  },
  formSubtext: {
    fontSize: '12px',
    textAlign: 'center',
    marginBottom: theme.spacing(),
    paddingTop: theme.spacing(2),
  },
  link: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: 'white',
    '&visited': {
      textDecoration: 'none',
      color: 'white',
    },
  },
  section: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(),
  },
  leftImg: {
    [theme.breakpoints.down(900)]: {
      width: '60%',
    },
    width: '100%',
    padding: theme.spacing(),
  },
  rightImg: {
    [theme.breakpoints.down(600)]: {
      width: '30%',
    },
    width: '20%',
  },
  text: {
    fontSize: '20px',
    fontFamily: 'Montserrat',
    margin: theme.spacing(2),
  },
  textNoBottomMargin: {
    fontSize: '20px',
    fontFamily: 'Montserrat',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textContainer: {
    paddingTop: theme.spacing(3),
  },
  asSeenInSection: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  asSeenInText: {
    textAlign: 'center',
    fontSize: '22px',
    fontWeight: '500',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
  },
  asSeenInLogo: {
    margin: theme.spacing(2),
    height: '30px',
    width: 'auto',
    [theme.breakpoints.down(900)]: {
      height: '20px',
    },
  },
  asSeenInContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '90%',
  },
  formSection: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  infusionForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  horizontalFields: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  infusionFieldInput: {
    margin: theme.spacing(1),
    backgroundColor: 'white',
  },
  button: {
    color: 'white',
    backgroundColor: '#f63c57',
    '&:hover': {
      backgroundColor: '#f52443',
    },
    '&:disabled': {
      backgroundColor: '#f86d82',
      color: 'white',
    },
    fontSize: '24px',
  },
  videoSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  outlinedBlueButton: {
    borderColor: DARK_BLUE,
    '&:hover': {
      borderColor: GREY,
    },
    color: DARK_BLUE,
    fontWeight: 'bold',
    marginTop: theme.spacing(3),
  },
  blueButton: {
    backgroundColor: DARK_BLUE,
    '&:hover': {
      backgroundColor: GREY,
    },
    color: 'white',
    fontWeight: 'bold',
    marginTop: theme.spacing(3),
  },
  blue: {
    color: DARK_BLUE,
  },
  buttonContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(20),
    marginTop: theme.spacing(5),
  },
  bottomSection: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up(900)]: {
      marginTop: theme.spacing(10),
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
    },
  },
  bottomSection2: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up(900)]: {
      marginTop: theme.spacing(5),
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
    },
    justifyContent: 'center',
  },
  soulsImg: {
    width: '60%',
  },
  fullSizeImg: {
    width: '100%',
  },
  shoesText: {
    width: '80%',
  },
  imgContainer: {
    textAlign: 'center',
  },
  scrollButtonContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(5),
  },
});

class BarefootDayPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inf_field_FirstName: '',
      inf_field_Email: '',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    // function scrollOnClick() {
    //   console.log("scrolling");
    //   scroller.scrollTo('scrolltoformheader', {
    //     duration: 200,
    //     delay: 100,
    //     smooth: true,
    //     offset: -120,
    //   });
    // }

    const {
      classes,
    } = this.props;
    const {
      inf_field_FirstName,
      inf_field_Email,
    } = this.state;
    function canSubmit() {
      if (inf_field_FirstName !== '' && inf_field_Email !== '') {
        return true;
      }
      return false;
    }
    return (
      <div className={classes.page}>
        <SimpleNavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <div className={classes.content}>
            <Grid container>
              {/* Header Section */}
              <Grid item xs={12} className={classNames(classes.headerImg, classes.headerImg2)} />
              <Grid item xs={12} md={4} className={classNames(classes.form, classes.white)}>
                <div className={classes.formContainer}>
                  {/* Form Section */}
                  <Element key="formheader" name="scrolltoformheader">
                    <Typography className={classes.formHeader}>
                      GET THE
                      <br />
                      REPLAY
                    </Typography>
                  </Element>
                  <form acceptCharset="UTF-8" action="https://sp877.infusionsoft.com/app/form/process/2d32f9b83463d4ec35c7fab2b5ef6dc3" className={classes.infusionForm} id="inf_form_2d32f9b83463d4ec35c7fab2b5ef6dc3" method="POST">
                    <input name="inf_form_xid" type="hidden" value="2d32f9b83463d4ec35c7fab2b5ef6dc3" />
                    <input name="inf_form_name" type="hidden" value="Web Form submitted" />
                    <input name="infusionsoft_version" type="hidden" value="1.70.0.462362" />
                    <div className={classes.horizontalFields}>
                      <TextField
                        required
                        className={classes.infusionFieldInput}
                        id="inf_field_FirstName"
                        name="inf_field_FirstName"
                        placeholder="First Name *"
                        type="text"
                        variant="outlined"
                        value={inf_field_FirstName}
                        onChange={this.handleChange}
                        inputProps={{ style: { fontSize: '18px' } }}
                      />
                      <TextField
                        required
                        className={classes.infusionFieldInput}
                        id="inf_field_Email"
                        name="inf_field_Email"
                        placeholder="Email *"
                        type="text"
                        variant="outlined"
                        value={inf_field_Email}
                        onChange={this.handleChange}
                        inputProps={{ style: { fontSize: '18px' } }}
                      />
                    </div>
                    <Button disabled={!canSubmit()} color="secondary" variant="outlined" size="large" className={classNames(classes.button, 'infusion-recaptcha')} id="recaptcha_2d32f9b83463d4ec35c7fab2b5ef6dc3" type="submit">SUBMIT</Button>
                  </form>
                  <script type="text/javascript" src="https://sp877.infusionsoft.app/app/webTracking/getTrackingCode" />
                  <script type="text/javascript" src="https://sp877.infusionsoft.com/resources/external/recaptcha/production/recaptcha.js?b=1.70.0.462362-hf-202205041133" />
                  <script src="https://www.google.com/recaptcha/api.js?onload=onloadInfusionRecaptchaCallback&render=explicit" async="async" defer="defer" />
                  <script type="https://sp877.infusionsoft.com/app/timezone/timezoneInputJs?xid=2d32f9b83463d4ec35c7fab2b5ef6dc3" />
                  <script type="text/javascript" src="https://sp877.infusionsoft.app/app/webform/overwriteRefererJs" />
                  <Typography className={classes.formSubtext}>
                    By signing up your agree to Nia&apos;s&nbsp;
                    <a className={classes.link} href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                    &nbsp;and&nbsp;
                    <a className={classes.link} href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    &nbsp;and opt-in to receive email communications from Nia
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} md={8} className={classes.headerContent}>
                <Typography variant="h1" className={classNames(classes.header, classes.uppercase, classes.red)}>
                  Dance Nia for &apos;Go Barefoot&apos; Day
                </Typography>
                <Typography variant="h1" className={classNames(classes.subheader, classes.uppercase, classes.red)}>
                  <span className={classes.underline}>Free </span>
                  online class + fundraiser benefiting
                </Typography>
                <a href="https://www.justgiving.com/fundraising/nationalbarefootdayniatechnique" target="_blank" rel="noopener noreferrer">
                  <img src={SolesForSouls} className={classes.soulsImg} alt="souls for souls turning clothing into opportunity" />
                </a>
                <Typography variant="h1" className={classNames(classes.large, classes.uppercase, classes.red)}>
                  Replay available until June 30, 2022
                </Typography>
              </Grid>
              <Grid item xs={12} className={classNames(classes.headerImg, classes.headerImg1)} />
            </Grid>
            <Grid container className={classes.bottomSection} direction="row-reverse">
              {/* row 1 */}
              <Grid item xs={12} md={9}>
                <img src={ShoesText} alt="the words kick off your shoes in cursive" className={classes.shoesText} />
                <Typography className={classes.text}>Sense your bare feet on the earth and experience the newest Nia routine EPIC with Master Nia Trainer Ann Christiansen for FREE while raising funds for a great cause in this 1 hour Nia experience.</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <div className={classes.imgContainer}>
                  <img src={AnnChristiansenHeadshot} alt="Ann Christiansen Nia teacher/trainer headshot" className={classes.leftImg} />
                </div>
              </Grid>
            </Grid>
            <Grid container className={classes.bottomSection2}>
              {/* row 2 */}
              <Grid item xs={6} md={2}>
                <img src={EpicCover} alt="album cover for Nia Epic Routine" className={classes.fullSizeImg} />
              </Grid>
              <Grid item xs={6} md={2}>
                <img src={FootPrints} alt="two cartoon footprints side by side" className={classes.fullSizeImg} />
              </Grid>
              <Grid item xs={12} className={classes.buttonContainer}>
                <Typography className={classes.blue}>Want to skip the class and donate directly?</Typography>
                <Button href="https://www.justgiving.com/fundraising/nationalbarefootdayniatechnique" target="_blank" rel="noopener noreferrer" size="large" variant="outlined" className={classes.outlinedBlueButton}>Donate Now</Button>
              </Grid>
            </Grid>
          </div>
        </main>
      </div>
    );
  }
}

BarefootDayPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BarefootDayPage);
